import React, { ReactNode } from 'react';
import { mergeClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { ClientType } from '@app/models/common/common';
import styles from './ApplySection.module.scss';
import BecomeInvestorForm from '@app/features/investors/BecomeInvestorForm/BecomeInvestorForm';
import BecomePartnerForm from '@app/features/partners/BecomePartnerForm/BecomePartnerForm';
import BecomeBorrowerForm from '@app/features/borrowers/BecomeBorrowerForm/BecomeBorrowerForm';
import SectionPart from '@app/ui/SectionPart/SectionPart';
import Image from '@app/components/Image/Image';

interface IConstants {
    title: ReactNode | string;
    form: (props: IProps) => ReactNode;
    background: string;
}

const CONSTANTS: Record<ClientType, IConstants> = {
    [ClientType.INVESTOR]: {
        title: <>Инвестируйте<br />вместе с JetLend</>,
        form: ({ sectionType }) => <BecomeInvestorForm sectionType={sectionType} type="button-block" buttonText="Начать инвестировать" />,
        background: '/next/assets/apply-background.png',
    },
    [ClientType.PARTNER]: {
        title: 'PARTNER',
        form: () => <BecomePartnerForm />,
        background: '/next/assets/apply-background.png',
    },
    [ClientType.BORROWER]: {
        title: 'BORROWER',
        form: () => <BecomeBorrowerForm />,
        background: '/next/assets/apply-background.png',
    },
};

interface IProps {
    /**
     * Тип секции для учета в аналитике.
     */
    sectionType?: string;
    type: ClientType;

    containerClassName?: string;
}

const ApplySection = (props: IProps) => {
    const {
        type,
        sectionType,
        containerClassName,
    } = props;

    return (
        <SectionPart
            className={mergeClassNames([styles['container'], containerClassName])}
            paddingSize="big"
        >
            <div className={styles['title']}>
                {CONSTANTS[type].title}
            </div>
            <div className={styles['form']}>
                {CONSTANTS[type].form(props)}
            </div>
            <Image src={CONSTANTS[type].background} fill alt="" className={styles['graph']} />
        </SectionPart>
    );
};

export default ApplySection;